export const Telco = 'cricwick';
